export default __webpack_public_path__ + "static/media/txjp_logo.c3cbadbc.png";